"use client";

import { useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

export function CookieConsent() {
  const t = useTranslations("cookies");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("cookie-consent");
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const accept = (choice: "necessary" | "all") => {
    localStorage.setItem("cookie-consent", choice);
    window.dispatchEvent(new CustomEvent("cookie-consent-change", { detail: choice }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] border-t border-edge bg-surface-1/95 backdrop-blur-xl shadow-2xl shadow-black/40">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 text-sm text-txt-secondary">
          <p>{t("message")}</p>
          <p className="mt-1 text-txt-muted">
            {t("learnMoreBefore")}{" "}
            <Link href="/privacy" className="underline hover:text-accent-400 transition-colors">
              {t("privacyPolicy")}
            </Link>{" "}
            {t("learnMoreAfter")}
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={() => accept("necessary")}
            className="px-4 py-2 text-sm font-medium text-txt-secondary bg-surface-3 border border-edge rounded-lg hover:bg-surface-4 transition-colors"
          >
            {t("necessaryOnly")}
          </button>
          <button
            onClick={() => accept("all")}
            className="px-4 py-2 text-sm font-medium text-surface-0 bg-accent-500 rounded-lg hover:bg-accent-400 transition-colors"
          >
            {t("acceptAll")}
          </button>
        </div>
      </div>
    </div>
  );
}
